import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutlined";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import isEmpty from "lodash/isEmpty";
import { Link } from "react-router-dom";
import InfiniteScroll from "../../components/infiniteScroll/InfiniteScroll";
import { useLimit } from "../../misc/useLimit";
import { formatDate } from "./formatDate";
import { useECommerceOffersByRegion } from "./useECommerceOffersByRegion";

export function ECommerceOffersInRegion(props: { region: string; exceptPackage: string }) {
  const { limit, loadMore } = useLimit(5);
  const { data: packages } = useECommerceOffersByRegion(props.region, [props.exceptPackage]);
  if (isEmpty(packages)) return <></>;
  return (
    <Paper elevation={0} sx={{ p: 4, borderRadius: 1, border: "1px solid rgba(0,0,0,0.08)", mt: 3 }}>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
          mb: 2,
        }}
      >
        <ShoppingCartCheckoutIcon color="primary" fontSize="small" />
        <Typography
          variant="subtitle2"
          sx={{
            textTransform: "uppercase",
            fontWeight: "bold",
            color: "text.secondary",
          }}
        >
          Gotowe wycieczki w tym regionie
        </Typography>
      </Stack>
      <InfiniteScroll
        dataLength={limit < packages.length ? limit : packages.length}
        hasMore={packages.length > limit}
        fetchData={loadMore}
        scrollableTarget={"ecommerce-offers-by-region"}
        maxHeight={570}
      >
        <Stack spacing={2}>
          {packages.map((pkg) => (
            <Box
              key={pkg.packageId}
              sx={{ p: 2, borderRadius: 1, bgcolor: "rgba(0,0,0,0.02)", border: "1px solid rgba(0,0,0,0.04)" }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  mb: 1,
                }}
              >
                {pkg.name}
              </Typography>
              <Stack direction="row" spacing={2} sx={{ mb: 1.5 }}>
                <Stack
                  direction="row"
                  spacing={0.5}
                  sx={{
                    alignItems: "center",
                  }}
                >
                  <CalendarTodayIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                  <Typography
                    variant="caption"
                    sx={{
                      color: "text.secondary",
                    }}
                  >
                    {formatDate(pkg.dates.from)} - {formatDate(pkg.dates.to)}
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  spacing={0.5}
                  sx={{
                    alignItems: "center",
                  }}
                >
                  <PeopleOutlineIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                  <Typography
                    variant="caption"
                    sx={{
                      color: "text.secondary",
                    }}
                  >
                    {pkg.participantsNumber} osób
                  </Typography>
                </Stack>
              </Stack>
              <Button
                variant="outlined"
                component={Link}
                size="small"
                fullWidth
                sx={{ borderRadius: 1.5, textTransform: "none", py: 0.5 }}
                to={`../${pkg.packageId}`}
              >
                Zobacz pakiet
              </Button>
            </Box>
          ))}
        </Stack>
      </InfiniteScroll>
    </Paper>
  );
}
